export const getJobTitleLabel = () => {
  try {
    const stored = localStorage.getItem("jobTitleLabel");
    if (stored && stored.trim().length > 0) {
      return stored.trim();
    }
  } catch (e) {
    // Ignore localStorage access errors and fall back to default
  }
  return "Booking";
};

export const getJobTitleLabelPlural = () => {
  const singular = getJobTitleLabel();
  if (!singular) return "Bookings";

  const lower = singular.toLowerCase();
  if (lower.endsWith("s")) {
    return singular;
  }

  return `${singular}s`;
};

export const getChargeOutRateTitle = () => {
  try {
    const stored = localStorage.getItem("chargeOutRateTitle");
    if (stored && stored.trim().length > 0) {
      return stored.trim();
    }
  } catch (e) {
    // Ignore localStorage access errors and fall back to default
  }
  return "Charge Out Rate";
};

export const getCostOfSupplyTitle = () => {
  try {
    const stored = localStorage.getItem("costOfSupplyTitle");
    if (stored && stored.trim().length > 0) {
      return stored.trim();
    }
  } catch (e) {
    // Ignore localStorage access errors and fall back to default
  }
  return "Cost of Supply";
};

